import { Container } from './styles'

export interface ButtonRadioProps {
  /**
   * Selected state
   */
  selected?: boolean

  /**
   * Children
   */
  children: React.ReactNode

  /**
   * onClick handler
   */
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

export const ButtonRadio = ({ children, ...rest }: ButtonRadioProps) => {
  return (
    <Container {...rest} type="button">
      {children}
    </Container>
  )
}
